import { render, staticRenderFns } from "./ModifierGroups.vue?vue&type=template&id=35b8d532&scoped=true"
import script from "./ModifierGroups.vue?vue&type=script&lang=js"
export * from "./ModifierGroups.vue?vue&type=script&lang=js"
import style0 from "./ModifierGroups.vue?vue&type=style&index=0&id=35b8d532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b8d532",
  null
  
)

export default component.exports